import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';
/**
 * Class used to create interceptors in Axios requests and responses
 */
export default class Interceptor {
  /**
   * Adds a new success request interceptor
   * @param callback Method that will be executed
   * @returns Interceptor id
   */
  public static addRequestSuccess(callback: (config: AxiosRequestConfig) => AxiosRequestConfig) {
    return axios.interceptors.request.use(callback);
  }

  /**
   * Adds a new fail request interceptor
   * @param callback Method that will be executed
   * @returns Interceptor id
   */
  public static addRequestFail(callback: (error: any) => any) {
    return axios.interceptors.request.use(undefined, callback);
  }

  /**
   * Adds a new success response interceptor
   * @param callback Method that will be executed
   * @returns Interceptor id
   */
  public static addResponseSuccess(callback: (response: AxiosResponse<any>) => AxiosResponse<any>) {
    return axios.interceptors.response.use(callback);
  }

  /**
   * Adds a new fail response interceptor
   * @param callback Method that will be executed
   * @returns Interceptor id
   */
  public static addResponseFail(callback: (error: AxiosError) => any) {
    return axios.interceptors.response.use(undefined, callback);
  }

  /**
   * Removes a request interceptor
   * @param id Interceptor id
   */
  public static removeRequestInterceptor(id: number) {
    axios.interceptors.request.eject(id);
  }

  /**
   * Removes a response interceptor
   * @param id Interceptor id
   */
  public static removeResponseInterceptor(id: number) {
    axios.interceptors.response.eject(id);
  }
}
